// components/BuscadorClienteFactura/FiltrosPopup.jsx - SOLO ARRIBA
import React from 'react';
import {
  Paper,
  Grid,
  Chip,
  Typography,
  Box
} from '@mui/material';
import { OPCIONES_FILTROS } from './constants';

const FiltrosPopup = ({ 
  filtrosSeleccionados, 
  onFiltroClick, 
  position = 'absolute',
  top = 'auto',    // ← CAMBIADO: 'auto' para usar bottom
  bottom = '100%', // ← NUEVO: se posiciona arriba
  left = 0,
  right = 0
}) => {
  return (
    <Paper 
      elevation={3} 
      sx={{ 
        position,
        top,        // 'auto' 
        bottom,     // '100%' - esto lo pone arriba del elemento
        left,
        right,
        zIndex: 10,
        p: 2,
        mb: 0.5,    // ← Margen en la parte inferior (ahora que está arriba)
        maxHeight: 200,
        overflow: 'auto',
        border: '1px solid #e0e0e0',
        borderRadius: 1
      }}
    >
      <Typography variant="caption" color="text.secondary" sx={{ mb: 1, display: 'block' }}>
        Seleccione los campos de búsqueda:
      </Typography>
      <Grid container spacing={0.5}>
        {OPCIONES_FILTROS.map((filtro) => (
          <Grid item key={filtro.value}>
            <Chip
              label={filtro.label}
              icon={<span>{filtro.icon}</span>}
              onClick={() => onFiltroClick(filtro.value)}
              color={filtrosSeleccionados.includes(filtro.value) ? "primary" : "default"}
              variant={filtrosSeleccionados.includes(filtro.value) ? "filled" : "outlined"}
              size="small"
            />
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default FiltrosPopup;